export enum DocumentProofTypes {
  AadharCard = 1,
  VoterIdentity = 4,
  DrivingLicense = 5,
  RationCard = 6,
  Registry = 12,
  OldTaxBill = 16,
  Others = 19,
}
